import { render, staticRenderFns } from "./SupportTools.vue?vue&type=template&id=615e9c74"
import script from "./SupportTools.vue?vue&type=script&lang=js"
export * from "./SupportTools.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports